import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
import App from "./App";
import Home from "./components/Home.js";
import ProductDetail from "./components/ProductDetail.js";
import FilterProduct from "./components/FilterProduct.js";
import CheckOut from "./components/CheckOut.js";
import OrderThankyouPage from "./components/OrderThankyouPage.js";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import { Provider } from "react-redux";
import {store} from "./store/index";
import { VENDOR_URL } from "./Constants.js";
import { fetchContentData } from "./store/ContentAction.js";
import { fetchVenueInfo } from "./store/slice/venueSlice.js";
import { fetchMenuFeedApi } from "./store/MenuFeedaction.js";
import { fetchMerchantInfo } from "./store/actions.js";
import { getDiscountData } from "./store/discountAction.js";
import { getSdpData } from "./store/SdpAction.js";
import { isWordPress } from "./utility/generalUtils";
import axios from "axios";
import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';
import {getCdnUrl} from "./sharedFunctions";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />
      },
      {
        path: "/:brands?/:product_id",
        element: <ProductDetail />
      },
      {
        path: "/checkout",
        element: <CheckOut />
      },
      {
        path: "/thank-you",
        element: <OrderThankyouPage />
      },
      {
        path: "/products",
        element: <FilterProduct />
      }
    ]
  }
], {
  basename: window.posabitmenuwidget.config.basename
}
);

async function fetchSettingsAndInitialize() {
  store.dispatch(fetchMerchantInfo());
  store.dispatch(fetchVenueInfo());
  store.dispatch(fetchContentData());
  store.dispatch(fetchMenuFeedApi());
  store.dispatch(getDiscountData());
  store.dispatch(getSdpData());
}

async function main() {
  // Check Query Params for overrides and set them in local storage
  const queryParams = new URLSearchParams(window.location.search);

  if (queryParams.has("merchant_token")) {
    sessionStorage.setItem('merchantToken', queryParams.get("merchant_token"));
  } else {
    sessionStorage.setItem('merchantToken', window.posabitmenuwidget.config.merchant_token);
  }

  if (queryParams.has("venue_slug")) {
    sessionStorage.setItem('selectedVenue', queryParams.get("venue_slug"));
  } else {
    sessionStorage.setItem('selectedVenue', window.posabitmenuwidget.config.venue_slug);
  }

  if (queryParams.has("merchant_slug")) {
    sessionStorage.setItem('merchantSlug', queryParams.get("merchant_slug"));
  } else {
    sessionStorage.setItem('merchantSlug', window.posabitmenuwidget.config.merchant_slug);
  }

  if (queryParams.has("initial_feed")) {
    sessionStorage.setItem('feedId', queryParams.get("initial_feed"));
  } else {
    sessionStorage.setItem('feedId', window.posabitmenuwidget.config.initial_feed_id);
  }

  if (queryParams.has("preview_mode")) {
    sessionStorage.setItem('previewMode', queryParams.get("preview_mode"));
  } else {
    sessionStorage.setItem('previewMode', window.posabitmenuwidget.config.preview_mode || false);
  }

  let apiHost = "";

  if (window.posabitmenuwidget.config.server_host) {
    apiHost = window.posabitmenuwidget.config.server_host;
  } else {
    let environment = "development";
    apiHost = VENDOR_URL;
    if (queryParams.has("environment")) {
      environment = queryParams.get("environment");
    } else {
      environment = window.posabitmenuwidget.config.environment;
    }

    if (environment === "development") {
      apiHost = "http://localhost:3000";
    } else if (environment === "vendor") {
      apiHost = VENDOR_URL;
    } else if (environment === "qa") {
      apiHost = "https://qa-app.posabit.com";
    } else {
      apiHost = "https://app.posabit.com";
    }
  }

  sessionStorage.setItem('apiHost', apiHost);

  // Fetch settings and initialize Redux store
  await fetchSettingsAndInitialize();
}

main();

function AppWithInterval() {
  useEffect(() => {
    const intervalId = setInterval(main, 20 * 60 * 1000);

    return () => clearInterval(intervalId); // Cleanup the interval on unmount
  }, []);

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}

function mountStandalone() {
  const container = document.getElementById('root');
  if (!container) return;
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <AppWithInterval />
    </React.StrictMode>
  );
}

function injectStyleSheet(shadowRoot, href) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  // optional: prevent flash of unstyled content by disabling until loaded
  // link.onload = () => link.disabled = false;
  // link.disabled = true;
  shadowRoot.appendChild(link);
}

let isShadowMounted = false;
function mountInShadow() {
  if (isShadowMounted) return;
  isShadowMounted = true;

  const host = document.querySelector('pb-wp-menu-app');
  if (!host) return;

  const shadow = host.attachShadow({ mode: 'open' });
  const reset = document.createElement('style');
  reset.textContent = `
    #posabit-app-reset,
    #posabit-app-reset *::before,
    #posabit-app-reset *::after {
      all: unset;
      box-sizing: border-box;
    }
  `;
  shadow.appendChild(reset);

  injectStyleSheet(shadow, 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.1/dist/css/bootstrap.min.css');

  const cdnUrl = getCdnUrl();
  injectStyleSheet(shadow, `${cdnUrl}css/style.css`);
  injectStyleSheet(shadow, `${cdnUrl}css/responsive.css`);
  injectStyleSheet(shadow, `${cdnUrl}static/css/main.css`);

  const wrapper = document.createElement('div');
  wrapper.id = 'posabit-app-reset';
  shadow.appendChild(wrapper);

  const mountPoint = document.createElement('div');
  wrapper.appendChild(mountPoint);

  ReactDOM.createRoot(mountPoint).render(
      <React.StrictMode>
        <StyleProvider container={wrapper}>
          <ConfigProvider getPopupContainer={() => wrapper}>
            <AppWithInterval />
          </ConfigProvider>
        </StyleProvider>
      </React.StrictMode>
  );
}

if (document.querySelector('pb-wp-menu-app')) {
  mountInShadow();
} else {
  mountStandalone();
}
